<template>
    <div class="button-group-three">
        <label ref="label-id" :for="name"> {{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip" style="white-space: pre-line;">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div :id="name" class="btn-group" role="group" aria-label="Basic example">
            <button v-on:click="activeChoiceOne" v-bind:class="{'active-button': isActiveOne}" type="button" id="low-button" class="btn">{{ buttonOneText }}</button>
            <button v-on:click="activeChoiceTwo" v-bind:class="{'active-button': isActiveTwo}" type="button" id="medium-button" class="btn">{{ buttonTwoText }}</button>
            <button v-on:click="activeChoiceThree" v-bind:class="{'active-button': isActiveThree}" type="button" id="high-button" class="btn">{{ buttonThreeText }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "button-group-three",
        data () {
            return {
                activeTooltip: false,
                isActiveOne: false,
                isActiveTwo: true,
                isActiveThree: false
            }
        },
        props: {
            name: String,
            label: String,
            buttonOneText: String,
            buttonTwoText: String,
            buttonThreeText: String,
            hasTooltip: Boolean
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            activeChoiceOne: function () {
                this.isActiveOne = true;
                this.isActiveTwo = false;
                this.isActiveThree = false;

                this.$emit('calcOne', this.buttonOneText);
            },
            activeChoiceTwo: function () {
                this.isActiveOne = false;
                this.isActiveTwo = true;
                this.isActiveThree = false;

                this.$emit('calcTwo', this.buttonTwoText);
            },
            activeChoiceThree: function () {
                this.isActiveOne = false;
                this.isActiveTwo = false;
                this.isActiveThree = true;

                this.$emit('calcThree', this.buttonThreeText);
            }
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            tooltipText: function () {

                return "The general quality and quantity of the building material & equipment. Some guides are below:\n" +
                    "\n" +
                    "Low – e.g. Laminate bench-tops, budget appliances, very basic inclusions etc\n" +
                    "\n" +
                    "Medium – e.g Mid-tier quality appliances, split system a/c, standard inclusions etc\n" +
                    "\n" +
                    "High – e.g Stone bench-tops, high-end European appliances, ducted a/c, superior quality inclusions etc\n";
            }
        },
        mounted () {
            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            });
        }
    }
</script>

<style scoped>

    label {
        float: left;
        font-size: 20px;
        color: #465978;
        width: 48% !important;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .btn {
        border: 1px solid rgb(206, 212, 218);
        font-size: 18px;
        padding: 1px 17.5px 3px 17.5px;
        color: #465978;
        white-space: normal
    }

    #low-button {
        padding-left: 5%;
        width: 28%;
        padding-right: 5%;
    }

    #medium-button {
        width: 44%;
        padding-left: 4%;
        padding-right: 4%;
    }

    #high-button {
        width: 28%;
        padding-left: 3%;
        padding-right: 3%;
    }

    .btn-group {
        width: 50%;
        margin-bottom: 16px;
        margin-left: auto;
        float: right;
        margin-top: 0;
        align-self: start
    }

    .button-group-three {
        width: 85%;
        margin: 0 auto;
        display: flex;
    }

    .active-button {
        background-color: #465978;
        color: #fff;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;

        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -299px;
        left: 0px;
        background-color: #465978;
        height: 298px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    @media (min-width: 1270px) and (max-width: 1426px) {
        label {
            width: 185px
        }
    }

    /*@media (min-width: 1211px) and (max-width: 1270px) {*/
        /*label {*/
            /*width: 158px*/
        /*}*/
    /*}*/

    @media (max-width: 1240px) {
        #medium-button {
            padding-left: 2%;
            padding-right: 2%;
        }
    }

    @media (max-width: 1170px) {
        #high-button {
            padding-left: 2%;
            padding-right: 2%;
        }
    }

    @media (max-width: 1140px) {
        #medium-button {
            padding-left: 1%;
            padding-right: 1%;
        }
    }

    @media (min-width: 900px) and (max-width: 1078px) {
        .btn {
            font-size: 16px;
        }
    }

    @media (min-width: 768px) and (max-width: 1015px) {

        #low-button {
            padding-left: 1%;
            padding-right: 1%;
        }

        #high-button {
            padding-left: 1%;
            padding-right: 1%;
        }
    }

    @media (min-width: 768px) and (max-width: 975px) {
        .btn {
            font-size: 15px;
        }

        #low-button {
            width: 26%;
        }

        #medium-button {
            width: 48%;
        }

        #high-button {
            width: 26%;
        }
    }

    @media (min-width: 768px) and (max-width: 920px) {
        #high-button {
            padding-left: 0;
            padding-right: 0;
        }
    }

    @media (min-width: 768px) and (max-width: 860px) {

        #low-button {
            width: 25%;
        }

        #medium-button {
            width: 49%;
        }

        #high-button {
            width: 28%;
        }
    }

    @media (max-width: 700px) {
        label {
            margin-right: 0;
        }

        .btn {
            padding-bottom: 1px;
        }
    }

    @media (max-width: 460px) {
        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 435px) {
        .btn-group {
            width: 50%;
        }

        #low-button {
            padding-left: 3%;
            padding-right: 3%;
            width: 25%;
        }

        #medium-button {
            width: 48%;
        }

        #high-button {
            width: 27%;
        }
    }

    @media (max-width: 410px) {

        #high-button {
            padding-left: 1%;
            padding-right: 1%;
        }
    }

    @media (max-width: 380px) {

        #low-button {
            font-size: 16px;
        }

        #medium-button {
            font-size: 16px;
        }

        #high-button {
            font-size: 16px;
        }
    }

    @media (max-width: 330px) {

        #low-button {
            padding-left: 0;
            padding-right: 0;
        }

        #high-button {
            padding-left: 0;
            padding-right: 0;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/ButtonGroupThree.vue